/* eslint-disable quotes */
// eslint-disable-next-line quotes
import hcOffcanvasNav from "hc-offcanvas-nav";

export default {
  init() {
    // JavaScript to be fired on all pages
    if (window.matchMedia("(max-width: 991px)").matches) {
      // do functionality on screens smaller than 768px
      new hcOffcanvasNav("#main-nav", {
        // disableAt: 991,
        // disableAt: false,
        width: 377,
        // eslint-disable-next-line quotes
        customToggle: ".toggle",
        // eslint-disable-next-line quotes
        levelOpen: "expand",
        // navTitle: {},
        // levelTitles: true,
        // levelTitleAsBack: true,
        // closeOpenLevels: true,
        // closeActiveLevel: true,
        disableBody: true,
        // eslint-disable-next-line quotes
        position: "right",
        // eslint-disable-next-line quotes
        labelBack: "กลับสู่เมนูหลัก",
        // eslint-disable-next-line quotes
        // pushContent: ".wrap",
      });

      var windownHeight = window.innerHeight;
      var detailBoxsearch = $(".detail-boxsearch").height() + 22;
      var topBoxSearch = windownHeight - detailBoxsearch;
      // console.log(windownHeight);
      // console.log(detailBoxsearch);
      $(".section-boxsearch").css("top", topBoxSearch);
      $(".detail-boxsearch").append('<div class="close-boxsearch"></div>');
      $("body").css("margin-bottom", $(".detail-boxsearch").height() + 22);
      $(".detail-boxsearch h2").click(function () {
        // $(".section-boxsearch").addClass("open-boxsearch");
        if ($(".section-boxsearch").hasClass("open-boxsearch")) {
          $(".section-boxsearch").removeClass("open-boxsearch");
          // $(".detail-boxsearch").remove('<div class="close-boxsearch"></div>');
        } else {
          $(".section-boxsearch").addClass("open-boxsearch");
          // $(".detail-boxsearch").append('<div class="close-boxsearch"></div>');
        }
      });
      $(".close-boxsearch").click(function () {
        $(".section-boxsearch").removeClass("open-boxsearch");
        // $(".detail-boxsearch").remove('<div class="close-boxsearch"></div>');
      });
    }
    if (window.matchMedia("(min-width: 992px)").matches) {
      var start_scroll = $(document).scrollTop();
      var header_menu = $(".section-topmenu").outerHeight();
      $(window).scroll(function () {
        var current_scroll = $(document).scrollTop();
        if (current_scroll > header_menu) {
          $("body").addClass("remove-menu");
          $(".section-boxsearch").css("top", header_menu);
        } else {
          $("body").removeClass("remove-menu");
          $(".section-boxsearch").css("top", "0");
        }
        if (current_scroll > start_scroll) {
          $("body").removeClass("show-menu");
          $(".section-boxsearch").css("top", "0");
        } else {
          $("body").addClass("show-menu");
          $(".section-boxsearch").css("top", header_menu);
        }
        start_scroll = $(document).scrollTop();
      });
    }

    if ($(".gallery_layout").length > 0) {
      $(".gallery_layout").lightGallery({
        // thumbnail: true,
        selector: ".gallery_item",
        exThumbImage: "data-exthumbimage",
        // autoplay: true,
        //                enableThumbSwipe: false,
        fullScreen: false,
        download: false,
        // captions: false,
        // lastRow: "hide",
        // rowHeight: 180,
        // margins: 5,
      });
    }

    $(".menu-item-has-children").click(function () {
      $(this).find(".sub-menu").toggleClass("active");
    });

    $(
      ".section-boxsearch, .section-bannerpage, .wrap, .section-footer, a"
    ).click(function () {
      if ($(".menu-item-has-children").find(".sub-menu").hasClass("active")) {
        $(".menu-item-has-children").find(".sub-menu").removeClass("active");
      }
    });

    $(window).scroll(function () {
      $(".menu-item-has-children").find(".sub-menu").removeClass("active");
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js